import { forwardRef, memo } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';

const BzInputText = forwardRef(({ type, placeholder, onChange,onBlur,min, max, autoFocus, value, onKeyDown=()=>{}, ...props }, ref) => {
/* Deepti B. 10050: added onKeyDown props */
    return (
        <Form.Control ref={ref} autoFocus={autoFocus} value={value} {...props} type={type} min={min} max={max} placeholder={placeholder} onKeyDown={(e) => onKeyDown(e)} onChange={onChange} onBlur={onBlur}></Form.Control>
    );
});
export default memo(BzInputText);

BzInputText.propTypes = {
    type: PropTypes.string,
    placeholder: PropTypes.string,
    min: PropTypes.number,
    max: PropTypes.number,
    autoFocus: PropTypes.bool
};

BzInputText.defaultProps = {
    type: "text",
    autoFocus: false,
};